import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-[#f8faff] text-[#1a2332] font-body">
      <Seo title="Mentions légales | DDSBillancourt" path="/mentions-legales" />
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-16 md:py-24">
        <Link to="/" className="inline-flex items-center gap-2 text-[#5b6577] hover:text-[#00a86b] text-sm font-headings font-semibold mb-8" data-testid="legal-back">
          <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
        </Link>

        <h1 className="font-headings font-black text-4xl md:text-5xl tracking-tight">Mentions légales</h1>
        <p className="mt-3 text-[#5b6577]">Conformément aux dispositions des articles 6-III et 19 de la loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'économie numérique (LCEN).</p>

        <div className="mt-10 space-y-8 prose prose-sm md:prose-base max-w-none">
          <Section title="1. Éditeur du site">
            <p><strong>DDSEmpire — Dynastie Drive School</strong><br />
            Auto-école agréée par la préfecture des Hauts-de-Seine<br />
            Adresse : 37 Avenue Édouard Vaillant, 92100 Boulogne-Billancourt<br />
            Téléphone : 01 41 31 50 61 · WhatsApp : +33 6 72 64 63 18<br />
            Email : dynastieblb@gmail.com<br />
            SIRET : 985 355 198 00040 · Numéro d'agrément préfectoral : E 25 092 0026 0<br />
            Directeur de la publication : représentant légal de Dynastie Drive School</p>
          </Section>

          <Section title="2. Hébergeur">
            <p>Le site <strong>ddsbillancourt.fr</strong> est hébergé par OVH SAS<br />
            2 rue Kellermann · 59100 Roubaix · France<br />
            Téléphone : 1007 (depuis la France)</p>
          </Section>

          <Section title="3. Propriété intellectuelle">
            <p>L'ensemble des éléments composant ce site (textes, images, logos, vidéos, charte graphique, code source, contenus pédagogiques des 36 cours, questions de quiz) est la propriété exclusive de DDSEmpire — Dynastie Drive School ou de ses partenaires. Toute reproduction, représentation, modification, publication, transmission ou exploitation, totale ou partielle, sans autorisation écrite préalable est strictement interdite et constituerait une contrefaçon sanctionnée par les articles L335-2 et suivants du Code de la propriété intellectuelle.</p>
          </Section>

          <Section title="4. Données personnelles (RGPD)">
            <p>Les données collectées via le formulaire de contact (nom, prénom, email, téléphone, formation souhaitée, message) ainsi que les données de la plateforme e-learning (progression, résultats aux quiz) sont traitées conformément au Règlement (UE) 2016/679 (RGPD) et à la loi Informatique et Libertés.</p>
            <p><strong>Finalités :</strong> traitement de la demande d'inscription, suivi pédagogique, déblocage progressif des cours, classement Légende du jeu concours, communication d'information sur les formations.</p>
            <p><strong>Durée de conservation :</strong> 3 ans après la fin de la relation contractuelle.</p>
            <p><strong>Vos droits :</strong> accès, rectification, suppression, limitation, portabilité, opposition. Pour les exercer, contactez-nous à dynastieblb@gmail.com. Vous disposez également du droit de saisir la CNIL (cnil.fr).</p>
          </Section>

          <Section title="5. Cookies">
            <p>Le site DDSEmpire utilise des cookies techniques nécessaires à son fonctionnement (authentification JWT, préférences linguistiques, état du Service Worker PWA). Aucun cookie publicitaire ou de tracking tiers n'est déposé sans votre consentement.</p>
          </Section>

          <Section title="6. Service Public d'éducation à la sécurité routière">
            <p>DDSEmpire est un établissement d'enseignement de la conduite et de la sécurité routière agréé par la préfecture des Hauts-de-Seine. Conformément à l'article L213-2 du Code de la route, un contrat écrit est obligatoirement conclu entre l'élève et l'établissement avant le commencement de la formation.</p>
          </Section>

          <Section title="7. Crédits">
            <p>Conception et développement : équipe DDSEmpire. Photographies : Unsplash (licence libre) et photographies internes Dynastie Drive School. Icônes : Lucide Icons. Police de caractères : Exo 2 et Inter (Google Fonts).</p>
          </Section>

          <Section title="8. Litiges">
            <p>Tout litige relatif à l'utilisation du site ddsbillancourt.fr est soumis au droit français. Les tribunaux français seront seuls compétents en cas de désaccord.</p>
          </Section>

          <Section title="9. Médiation de la consommation">
            <p>Conformément à l'article L612-1 du Code de la consommation, l'élève consommateur peut recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable du litige qui l'opposerait à l'auto-école. Médiateur compétent : à préciser dans le contrat de formation.</p>
          </Section>
        </div>

        <div className="mt-14 pt-8 border-t border-black/10 text-xs text-[#5b6577]">
          Dernière mise à jour : 12 juin 2026 · DDSEmpire — Dynastie Drive School
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-headings font-black text-xl md:text-2xl text-[#1a2332] mb-3">{title}</h2>
      <div className="text-[#3a4858] leading-relaxed space-y-2">{children}</div>
    </section>
  );
}
